import { lighten } from 'polished';
import styled from 'styled-components';

export const Container = styled.div<{ selectedOrderId: number | null }>`
  display: flex;
  width: ${(p) => (p.selectedOrderId === null ? '0px' : '100%')};
  height: ${(p) => (p.selectedOrderId === null ? '0px' : 'initial')};
  overflow: ${(p) => (p.selectedOrderId === null ? 'hidden' : 'initial')};
  flex-direction: column;
  transition: width 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  position: relative;
  overflow-y: auto;

  @media (min-width: 768px) {
    width: 100%;
    height: initial;
    flex: 1;
  }

  .button__close {
    background-color: #f5f5f5;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    position: absolute;
    top: 12px;
    left: 12px;

    @media (min-width: 768px) {
      display: none;
    }
  }
`;

export const ContainerInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 24px 16px 16px;
  gap: 20px;

  div.header {
    display: flex;
    flex-direction: column;
    gap: 24px;

    div.header__title {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;

      h1 {
        font-size: 1.8rem;
        font-weight: 600;

        span {
          font-weight: 400;
        }
      }

      p {
        color: #7c8db5;
        font-size: 16px;
        font-weight: 400;
      }

      .header__title__functions {
        display: flex;
        gap: 16px;
        align-self: center;

        div,
        button {
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          background: transparent;
          border: none;

          p {
            font-size: 0.9rem;
          }
        }
      }

      .a1 {
        display: none;
      }
    }

    @media (min-width: 1200px) {
      div.header__title {
        align-items: flex-start;

        div,
        button {
          display: flex;
          gap: 8px;
        }

        .a1 {
          display: flex;
          gap: 8px;

          div,
          button {
            border: none;
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 8px;
            background: #f1f2f4;
          }
        }

        .a2 {
          display: none;
        }
      }
    }

    div.header__buttons {
      display: flex;
      justify-content: center;
      gap: 8px;
      padding-bottom: 12px;

      button {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        font-size: 16px;
        font-weight: 600;
        border: none;
        color: #fff;
        border-radius: 4px;
        padding: 12px;
        animation: 0.3s;
        max-width: 300px;
      }

      button:nth-of-type(1) {
        background-color: #329bfc;
      }

      button:nth-of-type(1):hover {
        background-color: ${() => lighten(0.2, '#329bfc')};
      }

      button:nth-of-type(2) {
        background-color: #f64444;
      }

      button:nth-of-type(2):hover {
        background-color: ${() => lighten(0.2, '#f64444')};
      }

      button:nth-of-type(3) {
        background-color: #f57c00;
      }

      button:nth-of-type(3):hover {
        background-color: ${() => lighten(0.2, '#f57c00')};
      }

      button:disabled {
        background: #f5f5f5;
        color: #95989b;
      }

      .loader {
        border: 3px solid #f3f3f3;
        border-top: 3px solid #3498db;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        animation: spin 1s linear infinite;

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      }
    }
  }

  .order__info {
    display: flex;
    flex-direction: column;
    gap: 20px;

    @media (min-width: 800px) {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
  }

  .address {
    display: flex;
    flex-direction: column;
    gap: 20px;

    @media (min-width: 800px) {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
  }

  @media (min-width: 1200px) {
    div.header {
      flex-direction: row;
      justify-content: space-between;
    }

    div.header__buttons {
      align-items: center;

      button {
        width: 100px;
        height: 45px;
      }
    }
  }
`;

export const Section = styled.section`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  border: 2px solid #e6effb;
  border-radius: 4px;
  gap: 24px;

  &.programada,
  &.retirada,
  &.venda__balcao {
    padding: 12px;
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    gap: 8px;
    align-items: center;

    h2 {
      font-size: 14px;
      font-weight: 400;
    }

    svg {
      min-width: 20px;
      min-height: 20px;
    }
  }

  &.programada {
    display: flex;
    color: #ff8946;
    border-color: #ff8946;
    background-color: rgba(255, 243, 236, 1);
  }

  &.retirada {
    color: #329bfc;
    border-color: #329bfc;
    background-color: rgba(50, 155, 252, 0.07);
  }

  &.venda__balcao {
    color: #35ba83;
    border-color: #35ba83;
    background-color: rgba(53, 186, 131, 0.07);
  }

  .section__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    .section__header__icon {
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      border-radius: 4px;
      position: relative;
      cursor: pointer;
      border: none;
    }

    .whatsapp {
      background: #128c7e;
    }

    .waze {
      background: #32ccfe;
    }

    .section__header__icon::before,
    .section__header__icon::after {
      content: '';
      position: absolute;
      right: 0px;
      transform: translate(-50%, 3px);
      visibility: hidden;
      transition: transform 300ms;
    }
    .section__header__icon::before {
      top: 0px;
      border: 5px solid transparent;
      border-top: 5px solid #ffcc33;
    }
    .section__header__icon::after {
      content: attr(data-tooltip);
      top: -16px;
      padding: 4px;
      color: #000;
      font-size: 12px;
      background-color: #ffcc33;
      border-radius: 4px;
      white-space: nowrap;
    }
    .section__header__icon:hover::before {
      transform: translate(-50%, -100%);
      visibility: visible;
    }
    .section__header__icon:hover::after {
      transform: translate(0%, -100%);
      visibility: visible;
    }
  }

  @media (min-width: 1200px) {
    .section__header {
      align-items: center;
    }
  }

  .section__info {
    display: flex;
    flex-direction: column;
    gap: 8px;

    div {
      font-size: 12px;
      font-weight: 400;
      display: flex;
      justify-content: space-between;

      p:nth-child(2) {
        color: #7c8db5;
      }
    }
  }

  .section__itens {
    font-size: 12px;
    font-weight: 400;

    .order__item {
      display: flex;
      justify-content: space-between;
      flex-direction: row;

      .order__item__description {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 8px;
      }
    }

    .note {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 4px;
      padding-left: 8px;

      p:nth-child(1) {
        font-weight: 600;
      }

      p:nth-child(2) {
        color: #7c8db5;
      }
    }

    .order__item__complement {
      padding-left: 8px;
      display: flex;
      justify-content: space-between;
      gap: 8px;
      color: #7c8db5;
      align-items: center;

      div {
        display: flex;
        gap: 8px;

        p {
          white-space: nowrap;
        }
      }

      hr {
        width: 100%;
        height: 0px;
        border: none;
        border-top: 1px dashed #7c8db5;
      }
    }
  }

  .section__total {
    font-size: 12px;
    font-weight: 400;

    div {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 4px;
      justify-content: space-between;

      p:nth-child(1) {
        font-weight: 600;
      }

      p:nth-child(2) {
        color: #7c8db5;
      }
    }
  }

  .section__content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;

    @media (min-width: 1320px) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }

  iframe {
    width: 100%;
    height: 200px;
    border-radius: 8px;
    border: none;
  }
`;

export const DashedDivider = styled.div`
  display: flex;
  width: 100%;
  border: 1px dashed rgba(124, 141, 181, 0.25);
  margin: 8px 0px;
`;
